import React, { useState, useEffect, useMemo, useCallback, useContext, useRef } from "react";
import { Form, Button } from "react-bootstrap";
import { debounce } from "lodash";
import history from "../../helpers/history";
import { useForm } from "react-hook-form";
import FilterTable from "../../components/DataTable/filterTable";
import DataNotFound from "../../components/DataNotFound";
import api from "../../services/api";
import { toast } from "react-toastify";
import { ToastContext } from "../../contexts/toast/toastContext";
import { SweetAlertContext } from "../../contexts/sweetAlert/alertContext";
import { getSingleErrorMessage } from "../../helpers/getSingleErrorMessage";
import getValidationErrors from "../../helpers/getValidateErrors";
import { SubmitHandler, FormHandles } from "@unform/core";
interface IListLiga {
  idLiga: number,
  descricao: string,
  tempera: string,
  elasticidade: string,
  tensaoMaxima: string,
  acao: string,
}

const Ligas: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  //   //Fields Typed
  const DataTableTS: any = FilterTable;

  //   //Context
  const sweetAlertContext = useContext(SweetAlertContext);
  const toastContext = useContext(ToastContext);

  //   //States
  const [tableData, setTableData] = useState<IListLiga[]>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");


  //Effects
  useEffect(() => {
    (async () => {
      try {
        setTableLoading(true);
        const {data} = await api.get("liga/ObterLigaTempera");
        setTableData(data);
      } catch (err) {
        toast.error(getSingleErrorMessage(err));
        formRef.current?.setErrors(getValidationErrors(err));
      } finally {
        setTableLoading(false);
      }
    })();
  }, []);

  //   //Handles
  const handleEdit = ({ idLiga, descricao }: IListLiga) => {
    history.push(`/ligas/${idLiga}/${descricao}`);
  };

  const handleDelete = ({ idLiga, descricao }: IListLiga) => {
    const title = `Excluir "${descricao}"?`;
    const message = "Essa Liga será excluída, isso não pode ser desfeito.";
    sweetAlertContext.danger(title, message, async () => {
      try {

        await api.delete(`liga/Remover/${idLiga}`);

        setTableData((prevState) =>
          prevState.filter(function (item) {
            return item.idLiga !== idLiga;
          })
        );
        sweetAlertContext.close();
      } catch (error) {
        const message = getSingleErrorMessage(error);
        if (message) {
          toastContext.notification(message, "warn");
        } else {
          toastContext.notification(
            "Ocorreu um erro ao realizar essa operação.",
            "error"
          );
        }
      }
    });
  };

  const handleNew = () => {
    history.push(`/ligas/0/liga`);
  };
  const handleNewTempera = () => {
    history.push(`/ligas/0/tempera`);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Liga",
        accessor: "descricao",
        display: "align-middle",
      },
      {
        Header: "Tempera",
        accessor: "tempera",
        display: "align-middle",
      },
      {
        Header: "Elasticidade",
        accessor: "elasticidade",
        display: "align-middle",
      },
      {
        Header: "Tensão Máxima",
        accessor: "tensaoMaxima",
        display: "align-middle",
      },

      {
        Header: "Ação",
        accessor: "acao",
        disableSortBy: true,
        display: "align-middle column-table-2b",
        Cell: ({ row: { original } }: { row: { original: IListLiga } }) => (
          <>
            <Button
              title="Editar"
              variant="ghost-dark"
              className="p-2"
              onClick={() => handleEdit(original)}
            >
              <i className="far fa-edit icon m-0"></i>
            </Button>
            <Button
              title="Excluir"
              variant="ghost-dark"
              className="p-2"
              onClick={() => handleDelete(original)}
            >
              <i className="far fa-trash-alt icon m-0"></i>
            </Button>
          </>
        ),
      },
    ],
    []
  );

  return (
    <>
      <div className="content">
        <div className="container-xl">
          <div className="page-header">
            <div className="row">
              <h2 className="col-auto page-title">Ligas / Temperas</h2>
              <span className="col-auto ml-auto">
                <Button onClick={() => handleNew()} variant="white">
                  Nova Liga
                </Button>

              </span>
              <span className="col-auto">
                <Button onClick={() => handleNewTempera()} variant="white">
                  Nova Tempera
                </Button>
              </span>
              <span className="col-auto pr-0">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Busca..."
                  value={searchTerm || ""}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </span>
            </div>
          </div>

          <div className="row">
            <div className="card p-0">
              <div className="card-body">
                <div className={'dimmer' + (tableLoading ? ' active' : '')}>
                  <div className="loader"></div>
                  <div className={"dimmer-content" + (tableLoading ? ' medium-box-loader' : '')} >
                    {tableData && (
                      <DataTableTS
                        columns={columns}
                        data={tableData}
                        filter={searchTerm}
                        bordered={false}
                        initialState={{
                          sortBy: [
                            {
                              id: "id",
                              desc: false,
                            },
                          ],
                        }}
                      />
                    )}
                    <DataNotFound
                      visible={
                        tableLoading == false ? tableData?.length === 0 : false
                      }
                    ></DataNotFound>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ligas;
